import "core-js/stable";
import "regenerator-runtime/runtime";

// CSS
import "../src/css/vendor.scss";
